module.exports = __webpack_public_path__ + "static/img/video.a350c03b.gif";